export const PRODUCTS_UPDATE_PRODUCTS = 'PRODUCTS_UPDATE_PRODUCTS';
export const PRODUCTS_UPDATE_SCROLL_Y = 'PRODUCTS_UPDATE_SCROLL_Y';
export const PRODUCTS_UPDATE_SLUG = 'PRODUCTS_UPDATE_SLUG';
export const PRODUCTS_UPDATE_PAGES = 'PRODUCTS_UPDATE_PAGES';
export const PRODUCTS_UPDATE_SORT = 'PRODUCTS_UPDATE_SORT';
export const PRODUCTS_UPDATE_FACETS = 'PRODUCTS_UPDATE_FACETS';
export const PRODUCTS_UPDATE_META = 'PRODUCTS_UPDATE_META';
export const PRODUCTS_UPDATE_SLIDER = 'PRODUCTS_UPDATE_SLIDER';
export const PRODUCTS_UPDATE_TRACKING = 'PRODUCTS_UPDATE_TRACKING';
export const PRODUCTS_UPDATE_CLICKED_PRODUCT = 'PRODUCTS_UPDATE_CLICKED_PRODUCT';
